module.exports = __webpack_public_path__ + "static/media/customer012.cff8cd97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/img/customer012.jpg
// module id = 859
// module chunks = 0